import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  imageContainer: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 16,
    position: 'relative'
  },
  image: {
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
    cursor: 'pointer',
    flex: 1
  },
  imagePlus: {
    width: '100%'
  },
  smallScreen: {
    width: '100%',
    height: '100%'
  },
  cover: {
    height: 320,
    borderRadius: 8,
    display: 'block',
    width: '100%'
  },
  cover1: {
    width: '33%'
  },
  cover2: {
    width: '60%'
  },
  cover3: {
    width: '100%'
  },
  previewRow: {
    display: 'flex',
    gap: 8,
    width: '100%'
  },
  previewRowPlus: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gap: 64,
    justifyContent: 'center',
    padding: '0px 50px'
  },
  previewCarousel: {
    position: 'relative',
    width: '100%',
    display: 'flex',
    alignItems: 'center'
  },
  arrowLeft: {
    position: 'absolute',
    left: 0,
    zIndex: 2
  },
  arrowRight: {
    position: 'absolute',
    right: 0,
    zIndex: 2
  },
  arrow: { direction: 'rtl' },
  counter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    borderRadius: 8,
    background: 'rgba(0,0,0,0.4)'
  },
  iconText: {
    lineHeight: 1,
    fontWeight: 600,
    color: theme.palette.common.white,
    fontSize: 20
  }
}))

export default useStyles
